<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <div>
          <!-- Bara de instrumente -->
          <v-toolbar flat color="green">
            <v-btn color="white" @click="$router.go(-1)">{{ $t("clientDetails.back") }}</v-btn>
            <v-toolbar-title>
              <h2>{{ $t("clientDetails.title") }} - {{ client.NumeCompanie }}</h2>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-container fluid>
            <v-row dense>
              <!-- Cardul cu detalii despre client -->
              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="mx-auto my-4 single-restaurant-card"
                >
                  <v-card-title class="headline">
                    {{ client.NumeCompanie }}
                  </v-card-title>
                  <v-card-subtitle class="title">
                    {{ client.NumeRestaurant }}
                  </v-card-subtitle>
                  <v-card-text class="body-1">
                    <h3>{{ $t("clientDetails.company.info") }}</h3>
                    <p><strong>{{ $t("clientDetails.company.id") }}:</strong> {{ client.id }}</p>
                    <p>
                      <strong>{{ $t("clientDetails.company.name") }}:</strong> {{ client.NumeCompanie }}
                    </p>
                    <p>
                      <strong>{{ $t("clientDetails.company.restaurantName") }}:</strong>
                      {{ client.NumeRestaurant }}
                    </p>
                    <p>
                      <strong>{{ $t("clientDetails.company.contactPerson") }}:</strong>
                      {{ client.PersoanaContact }}
                    </p>
                    <p><strong>{{ $t("clientDetails.company.phone") }}:</strong> {{ client.NrTelefon }}</p>
                    <p><strong>{{ $t("clientDetails.company.email") }}:</strong> {{ client.Email }}</p>
                    <p>
                      <strong>{{ $t("clientDetails.company.registeredEmail") }}:</strong>
                      {{ client.EmailInregistrat }}
                    </p>
                    <p><strong>{{ $t("clientDetails.company.contractNumber") }}:</strong> {{ client.NrContract }}</p>
                    <p>
                      <strong>{{ $t("clientDetails.company.contractDate") }}:</strong>
                      {{ formatDate(client.DataContract) }}
                    </p>
                    <p><strong>{{ $t("clientDetails.company.startCost") }}:</strong> {{ client.CostStart }}</p>
                    <p>
                      <strong>{{ $t("clientDetails.company.paidAt") }}:</strong>
                      {{ formatDate(client.AchitatLa) }}
                    </p>
                    <p>
                      <strong>{{ $t("clientDetails.company.nextPayment") }}:</strong>
                      {{ formatDate(client.UrmatoareaAchitare) }}
                    </p>
                    <p><strong>{{ $t("clientDetails.company.annualCost") }}:</strong> {{ client.CostAnual }}</p>
                    <p>
                      <strong>{{ $t("clientDetails.company.salesManager") }}:</strong>
                      {{ client.ManagerVanzari }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Cardul cu Tipuri de Restaurante -->
              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="mx-auto my-4 single-restaurant-card"
                >
                  <v-card-text class="body-1">
                    <h3>{{ $t("clientDetails.types.title") }}</h3>
                    <div v-for="type in typeRestaurants" :key="type.ID">
                      <v-divider></v-divider>
                      <p><strong>{{ $t("clientDetails.types.id") }}:</strong> {{ type.ID }}</p>
                      <p><strong>Nume Menu:</strong> {{ type.NumeMenu }}</p>
                      <p>
                        <strong>{{ $t("clientDetails.types.restaurantType") }}:</strong>
                        {{ type.TypeRestaurant }}
                      </p>
                      <p>
                        <strong>{{ $t("clientDetails.types.link") }}:</strong>
                        <a :href="type.Link" target="_blank">{{ type.Link }}</a>
                      </p>
                      <p>
                        <strong>{{ $t("clientDetails.types.active") }}:</strong>
                        <v-switch v-model="type.Activ" disabled></v-switch>
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Cardul cu Plăți Clienți -->
              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="mx-auto my-4 single-restaurant-card"
                >
                  <v-card-text class="body-1">
                    <h3>{{ $t("clientDetails.payments.title") }}</h3>
                    <div v-for="plata in platiClienti" :key="plata.ID">
                      <v-divider></v-divider>
                      <p><strong>{{ $t("clientDetails.payments.id") }}:</strong> {{ plata.ID }}</p>
                      <p>
                        <strong>{{ $t("clientDetails.payments.date") }}:</strong>
                        {{ formatDate(plata.DataAchitarii) }}
                      </p>
                      <p><strong>{{ $t("clientDetails.payments.service") }}:</strong> {{ plata.Serviciul }}</p>
                      <p>
                        <strong>{{ $t("clientDetails.payments.amount") }}:</strong> {{ plata.SumaAchitata }}
                      </p>
                      <p>
                        <strong>{{ $t("clientDetails.payments.method") }}:</strong>
                        {{ plata.MetodaPlata }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  props: ["id"],
  data() {
    return {
      client: {},
      typeRestaurants: [],
      platiClienti: [],
    };
  },
  created() {
    this.fetchClientDetails();
  },
  methods: {
    fetchClientDetails() {
      // Obține datele clientului din tabela auronda
      axios
        .get(`/auronda/${this.id}`)
        .then((response) => {
          this.client = response.data;
        })
        .catch((error) => {
          console.error("Eroare la preluarea datelor clientului:", error);
        });

      // Obține datele din TypeRestaurants
      axios
        .get(`/infinireportTabele/typerestall`, {
          params: { ID_Auronda: this.id },
        })
        .then((response) => {
          this.typeRestaurants = response.data;
        })
        .catch((error) => {
          console.error("Eroare la preluarea datelor TypeRestaurants:", error);
        });

      // Obține datele din plati_clienti
      axios
        .get(`/infinireportTabele/paid-details`, {
          params: { ID_Auronda: this.id },
        })
        .then((response) => {
          this.platiClienti = response.data;
        })
        .catch((error) => {
          console.error("Eroare la preluarea plăților clientului:", error);
        });
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return dateString.split("T")[0];
    },
  },
};
</script>

<style scoped>
.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.headline {
  font-size: 24px;
}

.title {
  font-size: 20px;
}

.body-1 {
  font-size: 18px;
}

.single-restaurant-card {
  background-color: white;
  color: black;
  border: 1px solid #000;
}

.v-divider {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
